import React from "react";
import { LEGAL_PRIVACY_URL } from "../config/legalUrls";
import LegalMarketingRedirect from "./LegalMarketingRedirect";

const PrivacyPolicyPage = () => (
  <LegalMarketingRedirect url={LEGAL_PRIVACY_URL} testId="privacy-policy-page" />
);

export default PrivacyPolicyPage;
